<template>
  <div class="definition-controls">
    <button @click="groupAttributes" :disabled="groupDisable || isDragAndDropActive" title="Group (g)">
      <svg-icon id="definition-controls__group" :icon="group" :width="18" :height="18"></svg-icon>
    </button>
    <button @click="ungroupAttributes" :disabled="ungroupDisable || isDragAndDropActive" title="Ungroup (u)">
      <svg-icon id="definition-controls__ungroup" :icon="ungroup" :width="18" :height="18"></svg-icon>
    </button>
    <button @click="countGroupHandler" :disabled="countGroupDisable || isDragAndDropActive">
      <svg-icon :icon="countGroupIcon" :width="18" :height="18"></svg-icon>
    </button>
    <button title="Drag and drop mode" :class="{'active': isDragAndDropActive}" @click="dragAndDropModeToggle">
      <svg-icon id="definition-controls__arrows" :icon="arrows"></svg-icon>
    </button>
    <button @click="deleteAttributes" :disabled="deleteDisable || isDragAndDropActive" title="Delete (Delete/Backspace)">
      <svg-icon id="definition-controls__trash" :icon="trash" :width="15" :height="18"></svg-icon>
    </button>
    <button title="History" :class="{'active': isDragAndDropActive}" @click="showHistory">
      <svg-icon id="definition-controls__history" :icon="history"></svg-icon>
    </button>
  </div>
</template>

<script>
  import group from '@/assets/svg/group.svg'
  import ungroup from '@/assets/svg/ungroup.svg'
  import trash from '@/assets/svg/trash.svg'
  import arrows from '@/assets/svg/arrows.svg'
  import countGroup from '@/assets/svg/count-group.svg'
  import removeCountGroupIcon from '@/assets/svg/remove-count-group.svg'
  import history from '@/assets/svg/history.svg'
  import SvgIcon from '@/components/common/svgIcon'
  import { isCountGroup } from '@/appComponents/oldWorkbench/targetDefinition/store/mutations'
  import { createPopover, popoverTypes } from '@/components/common/popover'
  import {
    GROUP,
    UNGROUP,
    REMOVE_ATTRIBUTE,
    ACTIVATE_DRAG_DROP,
    DEACTIVATE_DRAG_DROP,
    CREATE_COUNT_GROUP,
    REMOVE_COUNT_GROUP
  } from '@/appComponents/oldWorkbench/targetDefinition/store/actions'
  import { SHOW_TARGET_HISTORY_PANEL } from '@/views/workbenchCanvas/store/WorkbenchWCanvasSlotActionsGenerator'

  export default {
    components: {
      SvgIcon
    },
    data () {
      return {
        group,
        ungroup,
        trash,
        arrows,
        countGroup,
        removeCountGroupIcon,
        history
      }
    },
    computed: {
      groupDisable () {
        return !this.$store.getters.selectedCanBeGrouped
      },
      ungroupDisable () {
        return !this.$store.getters.selectedCanBeUngrouped
      },
      deleteDisable () {
        return !this.$store.getters.selectedCanBeDeleted
      },
      isDragAndDropActive () {
        return this.$store.getters.isDragAndDropActive
      },
      countGroupDisable () {
        return !this.$store.getters.selectedCanBecomeCountGroup
      },
      isSelectedACountGroup () {
        if (!this.$store.getters.hasOwnProperty('selectedAttributes')) return
        const attribute = this.$store.getters.selectedAttributes[0]
        if (!attribute) return false
        return isCountGroup(attribute)
      },
      countGroupIcon () {
        return this.isSelectedACountGroup ? removeCountGroupIcon : countGroup
      }
    },
    methods: {
      groupAttributes () {
        this.$store.dispatch(GROUP)
      },
      ungroupAttributes () {
        this.$store.dispatch(UNGROUP)
      },
      deleteAttributes () {
        this.$store.dispatch(REMOVE_ATTRIBUTE)
      },
      dragAndDropModeToggle () {
        this.isDragAndDropActive ? this.$store.dispatch(DEACTIVATE_DRAG_DROP) : this.$store.dispatch(ACTIVATE_DRAG_DROP)
      },
      countGroupHandler (e) {
        const attribute = this.$store.getters.selectedAttributes[0]
        this.isSelectedACountGroup ? this.removeCountGroup(attribute.definitionId) : this.createCountGroup(e, attribute)
      },
      createCountGroup (e, attribute) {
        // add popover to chose the count for the new group
        // have to get the count group attribute
        this.popover = createPopover({
          direction: 'left',
          attribute: attribute,
          parent: e.target,
          root: document.getElementById('app'),
          type: popoverTypes.COUNT_GROUP
        })
        this.popover.$on('select', value => {
          const details = {
            groupId: attribute.definitionId,
            mustMatch: value
          }
          this.$store.dispatch(CREATE_COUNT_GROUP, details)
        })
      },
      removeCountGroup (groupId) {
        this.$store.dispatch(REMOVE_COUNT_GROUP, groupId)
      },
      showHistory () {
        this.$store.dispatch(SHOW_TARGET_HISTORY_PANEL, true)
      }
    }
  }
</script>

<style lang="scss">
  #definition-controls {
    &__group {
      width: rem(18) !important;
      height: rem(18) !important;
    }
    &__ungroup {
      width: rem(18) !important;
      height: rem(18) !important;
    }
    &__trash {
      width: rem(15) !important;
      height: rem(18) !important;
    }
    &__arrows {
      width: rem(20) !important;
      height: rem(20) !important;
    }
    &__history {
      width: rem(20) !important;
      height: rem(20) !important;
    }
  }
  .definition-controls {
    display: flex;
    flex-wrap: wrap;
    max-height: 100%;
    width: rem(92px);

    button {
      margin: rem(5) rem(2.5) 0;
      width: rem(40);
      height: rem(40);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: rem(4);
      background: black;
      border: none;

      svg {
        margin: auto;
        fill: white
      }

      &:focus {
        outline: none;
      }

      &:hover, &.active {
        svg {
          fill: color(yellow)
        }
      }
      &:disabled {
        opacity: .3;

        &:hover {
          cursor: not-allowed;
          svg {
            fill: white;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// DefinitionControls.vue?48f51309